import React from "react";
import { StaticQuery, graphql } from "gatsby"
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import mappings from "../config/gallery-mappings";
import styles from './gallery-carousel.module.css';

export default class GalleriesModal extends React.Component {
    constructor(props) {
        super(props);
    }

    buildModal(data) {
        return data.allDirectory.edges.map(edge => edge.node)
            .map(node => (
                <Col md={3} xs={4}>
                    <a href={"/gallery/" + node.name}>
                        <Image
                            rounded
                            className={styles.thumb}
                            src={require("../images/galleries/" + node.name + "/" + mappings[node.name].cover + ".thumb.jpg")} />
                        <p>{mappings[node.name].label}</p>
                    </a>
                </Col>
            ));
    }

    render() {
        return <StaticQuery
            query={graphql`
    query {
        allDirectory(filter: {sourceInstanceName: {eq: "galleries"}, name: {ne: "galleries"}}) {
          edges{
            node{
              name
            }
          }
        }
      }
`}
            render={data => (
                <>
                    <Modal
                        size="xl"
                        show={this.props.showAll}
                        onHide={ this.props.onHide }
                        centered>
                        <Modal.Header closeButton />
                        <Modal.Body>
                            <Container fluid>
                                <Row style={{ textAlign: "center" }}>
                                    {this.buildModal(data)}
                                </Row>
                            </Container>
                        </Modal.Body>
                    </Modal>
                </>
            )}
        />
    }
}